export default "/imgs/investigation-03-mob.png"